export default function getVMSlotsArray(list) {
  if (!list) return null;
  const slotObject = [];

  slotObject.push(list.filter(el => el.slot_identifier.startsWith('1')));
  slotObject.push(list.filter(el => el.slot_identifier.startsWith('2')));
  slotObject.push(list.filter(el => el.slot_identifier.startsWith('3')));
  slotObject.push(list.filter(el => el.slot_identifier.startsWith('4')));
  slotObject.push(list.filter(el => el.slot_identifier.startsWith('5')));
  slotObject.push(list.filter(el => el.slot_identifier.startsWith('6')));
  slotObject.push(list.filter(el => el.slot_identifier.startsWith('7')));
  slotObject.push(list.filter(el => el.slot_identifier.startsWith('8')));
  slotObject.push(list.filter(el => el.slot_identifier.startsWith('9')));

  return slotObject;
}



// WEBPACK FOOTER //
// ./src/utils/convertToSlots.js